import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  alpha,
} from '@mui/material';
import { Group } from '@mui/icons-material';

interface FamilyCenterTabProps {
  colors: any;
  glassStyle: any;
  isDark: boolean;
}

const FamilyCenterTab: React.FC<FamilyCenterTabProps> = ({ colors, glassStyle, isDark }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Family Center
      </Typography>
      <Paper elevation={0} sx={{ 
        bgcolor: colors.cardBg, 
        borderRadius: '24px', 
        p: 4, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        textAlign: 'center', 
        minHeight: 400, 
        justifyContent: 'center', 
        ...glassStyle 
      }}>
        <Box sx={{ 
          width: 80, 
          height: 80, 
          bgcolor: alpha(colors.accent, 0.1), 
          borderRadius: '50%', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          mb: 3 
        }}>
          <Group sx={{ fontSize: 40, color: colors.accent }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={colors.textPrimary} gutterBottom>
          Connect with your teen
        </Typography>
        <Typography color={colors.textSecondary} sx={{ maxWidth: 400, mb: 4 }}>
          Family Center helps you stay informed about who your teen is talking to and what groups they are in, without seeing their messages.
        </Typography>
        <Button 
          variant="contained" 
          sx={{ 
            bgcolor: colors.accent, 
            borderRadius: '24px', 
            fontWeight: 700, 
            px: 4, 
            py: 1.5, 
            color: isDark ? '#000' : '#fff' 
          }}
        >
          Connect with Teen
        </Button>
      </Paper>
    </Box>
  );
};

export default FamilyCenterTab;